import React from 'react';
import { Button, Stack, Typography, Box } from '@mui/material';

import { DialogTitle, DialogContent, DialogActions } from '/packages/shared-components/Dialog/Dialog';

export interface UnsavedChangesModalProps {
  handleModalClose: () => void;
  onDiscard: () => void;
}

const UnsavedChangesModal = ({ handleModalClose, onDiscard }: UnsavedChangesModalProps) => {
  return (
    <Box sx={{ width: '444px' }} data-cy="unsaved-changes-modal">
      <DialogTitle sx={{ textAlign: 'center' }}>Unsaved Changes</DialogTitle>
      <DialogContent>
        <Stack gap={3}>
          <Typography variant="body1">
            You are about to leave without saving.
            <br />
            Are you sure you wish to discard your changes?
          </Typography>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Stack direction="row" gap={2}>
          <Button variant="text" size="small" onClick={handleModalClose} data-cy="unsaved-cancel-btn">
            Cancel
          </Button>
          <Button variant="contained" size="small" onClick={onDiscard} data-cy="discard-changes-btn">
            Discard Changes
          </Button>
        </Stack>
      </DialogActions>
    </Box>
  );
};

export default UnsavedChangesModal;
